import React from "react";
import ReactDOM from "react-dom/client";
import "./fetchInterceptor";
import "@/index.css";
import App from "@/App";
import { installClientErrorReporter } from "@/lib/clientErrorReporter";

// Forward unhandled JS errors + promise rejections to /api/client-errors
// so we see real production crashes in the owner-admin dashboard before
// customers complain.
installClientErrorReporter();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
